import '@stripe/stripe-js'

import App from '@page/App'
export default App
